import conversionSet from './conversion-set'
import './emit-page-view-event'
import App from 'frontend/app'

function handleDomReady () {
  handleDatasetAnalyticAccounts()
  handleCurrentOrderAnalyticsAccounts()
}

function handleDatasetAnalyticAccounts () {
  if (!document.body.dataset.analyticsAccounts) {
    console.warn('no document.body.dataset.analyticsAccounts found')
    return
  }
  const analyticsAccounts = JSON.parse(document.body.dataset.analyticsAccounts)
  conversionSet.addAccountIDs(analyticsAccounts)
}

async function handleCurrentOrderAnalyticsAccounts () {
  const order = await App.currentOrder
  if (!order?.location?.analyticsAccounts) {
    console.info('App.currentOrder.location.analyticsAccounts empty')
    return
  }
  conversionSet.addAccountIDs(order.location.analyticsAccounts)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', handleDomReady)
} else {
  setTimeout(handleDomReady, 0)
}
